import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { MainserviceService } from '../../mainservices/mainservice.service';
import { SubservicesService } from '../../subservices/subservices.service';
import { MainService } from '../../mainservices/mainservices.model';
import { SubServices } from '../../subservices/subservices.model';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SubservicesfieldsService } from '../subservicesfields.service';
import { SubServicesField } from '../subservicesfield.model';

@Component({
  selector: 'app-subservicesfieldsform',
  templateUrl: './subservicesfieldsform.component.html',
  styleUrls: ['./subservicesfieldsform.component.css']
})
export class SubservicesfieldsformComponent implements OnInit {

  subServiceFieldsForm!: FormGroup

  mainServiceList: MainService[] = [];
  subServicesList: SubServices[] = [];
  subServicesFieldsList: SubServicesField[] = [];
  mainServicestatusList: { id: boolean, name: string }[] = [];
  spinnerOverlay = false;
  constructor(
    private mainService: MainserviceService,
    private subServiceService: SubservicesService,
    private service: SubservicesfieldsService,
    private translateService: TranslateService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.connectFormGroup()

    this.mainServicestatusList = [{ id: true, name: this.translateService.instant("active") },
    { id: false, name: this.translateService.instant("notActive") }];

    this.getMainService();
  }

  connectFormGroup() {

    let _subServiceFields = new FormArray([]);

    this.subServiceFieldsForm = new FormGroup({

      id: new FormControl(null),
      mainServiceId: new FormControl(null, [
        Validators.required
      ]),
      mainServiceStatus: new FormControl(true),
      subServiceId: new FormControl(null, [
        Validators.required
      ]),
      subServiceFields: _subServiceFields!,
    });

    this.addSubServiceFieldsRow();
    // this.getUserCategory();
  }

  getSubServiceFieldsControls() {
    return (<FormArray>this.subServiceFieldsForm.get('subServiceFields')).controls;
  }

  addSubServiceFieldsRow() {
    (<FormArray>this.subServiceFieldsForm.get('subServiceFields')).push(
      new FormGroup({
        id: new FormControl(""),
        label: new FormControl(''),
        type: new FormControl(''),
        dataType: new FormControl('')
      }))
  }

  deleteRow(index: number) {

    const control = (<FormArray>this.subServiceFieldsForm.get('subServiceFields'));
    if (control.length != 1)
      control.removeAt(index);

  }

  selectMainServiceStatusChange() {
    this.getMainService();

  }

  getMainService() {
    this.mainService.getAll(this.subServiceFieldsForm.value.mainServiceStatus).subscribe(data => {
      this.mainServiceList = data

    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
      })
  }

  onSelectMainService() {
    const subServiceFieldsArray = <FormArray>this.subServiceFieldsForm.get('subServiceFields');
    subServiceFieldsArray.clear();
    this.addSubServiceFieldsRow();
    this.getSubService()
  }

  getSubService() {
    this.spinnerOverlay = true;
    this.subServiceService.getAll(this.subServiceFieldsForm.value.mainServiceId, true).subscribe(data => {
      this.subServicesList = data;
      this.spinnerOverlay = false;
    })
  }

  onSelectSubServices() {
    const subServiceFieldsArray = <FormArray>this.subServiceFieldsForm.get('subServiceFields');
    subServiceFieldsArray.clear();
    this.addSubServiceFieldsRow();
    this.get();
  }

  get() {
    this.spinnerOverlay = true;
    this.subServicesFieldsList = [];

    this.service.getAll(this.subServiceFieldsForm.value.subServiceId).subscribe(data => {
      this.subServicesFieldsList = data;
      this.fillControl();
      this.spinnerOverlay = false
    }, error => {
      console.log(error)
      this.spinnerOverlay = false;
    })
  }


  fillControl() {

    if (this.subServicesFieldsList.length > 0) {
      (<FormArray>this.subServiceFieldsForm.get('subServiceFields')).removeAt(0);
    }
    for (let i = 0; i < this.subServicesFieldsList.length; i++) {

      (<FormArray>this.subServiceFieldsForm.get('subServiceFields')).push(
        new FormGroup({
          id: new FormControl(this.subServicesFieldsList[i].id),
          label: new FormControl(this.subServicesFieldsList[i].label),
          type: new FormControl(this.subServicesFieldsList[i].type.toString()),
          dataType: new FormControl(this.subServicesFieldsList[i].dataType)
        }));
    }

    // this.disableControlsOnUpdate();
    // this.addProductCardRow();

  }

  submit() {
    this.create();
    // this.ProductForm.get("subCategoryId")!.setValue(this.ProductForm.get("subCategory")!.value['id']);
    // this.ProductForm.get("cardsHowToUse")?.setValue(this.product.cardsHowToUse);

    // if (this.files.length > 0) {
    //   this.uploadImage();
    // }
    // else {
    //   !this.updateMode ? this.create() : this.update();
    // }
  }

  create() {
    this.spinnerOverlay = true;
    var subServiceField = this.subServiceFieldsForm.value.subServiceFields;
    var listSubServiceFields = [];

    for (let i = 0; i < subServiceField.length; i++) {
      var obj = {
        id: subServiceField[i].id != "" && subServiceField[i].id != null ?
          subServiceField[i].id : 0,
        type: subServiceField[i].type,
        dataType: subServiceField[i].dataType,
        label: subServiceField[i].label,
        subServiceId: this.subServiceFieldsForm.value.subServiceId
      }
      listSubServiceFields.push(obj)

    }

    this.service.CreateUpdate(listSubServiceFields).subscribe(data => {
      this.openSnackBar(this.translateService.instant("createdSuccessfully"), 'snackBarSuccess');
      // this.get();
      this.spinnerOverlay = false
    },
      error => {
        console.log(error);
        if (error.error.message != undefined) {
          this.openSnackBar(error.error.message, 'snackBarError');
        }
        else {
          this.openSnackBar("Internal server error", 'snackBarError');
        }

        this.spinnerOverlay = false;
      })
  }

  openSnackBar(message: any, cssclass: any) {
    this.snackBar.open(message, 'X', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }
}
